import { useContext, useEffect, useState } from 'react';
import Overlay from '@alifd/next/lib/overlay';
import { BefGlobalContext, BefMessageServiceContext } from '@beflam/bef-core';
import { AllColleagues } from './AllColleagues';
import { fetchAIUserList } from './aiColleagueService';

export function ColleagueOverlay(props: any) {
  const [visible, setVisible] = useState<boolean>(false);
  const messageService = useContext(BefMessageServiceContext);
  const sGlobal = useContext(BefGlobalContext) as any;
  const [aiUserList, setAiUserList] = useState<any>([]); // {Id: '',Name: ''}
  const onVisibleChange = (evt: any) => {
    setVisible(evt);
  };
  const refresh = async (_isShow: boolean = false) => {
    getAIUserList();
  };

  const getAIUserList = async () => {
    try {
      const list = await fetchAIUserList(sGlobal);
      setAiUserList(list);
      if (list.length === 0 && visible) {
        messageService.showMessage(
          messageService.handleErr('未获取到AI同事', 'AI同事')
        );
      }
    } catch (error) {
      messageService.showMessage(messageService.handleErr(error, 'AI同事'));
    }
  };

  const handleSelectOK = (colleague: any) => {
    setVisible(false);
    props.onOk?.(colleague);
  };

  //每次显示时获取一次列表
  useEffect(() => {
    if (visible) {
      refresh();
    }
  }, [visible]);

  //初始化时获取一次列表
  useEffect(() => {
    refresh();
  }, []);

  return (
    <>
      <Overlay.Popup
        v2
        triggerType="click"
        placement="r"
        trigger={
          <a
            className="J_menuItem"
            onClick={() => {
              setVisible(!visible);
            }}
          >
            <i className="glyphicon glyphicon-user" aria-hidden="true" />
            <span className="bef-menu-label">AI同事</span>
          </a>
        }
        visible={visible}
        onVisibleChange={onVisibleChange}
      >
        <div
          style={{ paddingLeft: '25px', width: '772px', height: '90%' }}
          className="custom-left-menu"
        >
          <AllColleagues
            onOK={handleSelectOK}
            data={aiUserList}
          ></AllColleagues>
        </div>
      </Overlay.Popup>
    </>
  );
}
